import { ajax } from "../utils/ajax";
import { soilChargeEngineeringProjects } from "../.fakeDatas/soilChargeEngineeringProject";

const timeoutPromise = (data, timeout, isReject = false) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      isReject ? reject(data) : resolve(data);
    }, timeout);
  });
};

export const soilChargeEngineeringProjectService = {
  /**
   * Send Get All Soil Charge Engineering Project Ajax Request.
   */
  getAll(condition) {
    // return timeoutPromise(soilChargeEngineeringProjects.soilChargeEngineeringProjectsGetAll, 1000);
    // return timeoutPromise("查詢失敗", 1000, true);

    return ajax
      .get(`${process.env.REACT_APP_API_URL}/soil-charge-engineering-projects`, {
        params: {
          ...condition
        }
      })
      .then(response => response.json())
      .then(res => (res.status !== 200 ? Promise.reject(res.message) : res.data));
  },
  /**
   * Send Get Soil Charge Engineering Project List Ajax Request.
   */
  getList() {
    // return timeoutPromise(soilChargeEngineeringProjects.soilChargeEngineeringProjectsGetList, 1000);
    // return timeoutPromise("讀取失敗", 1000, true);

    return ajax
      .get(`${process.env.REACT_APP_API_URL}/soil-charge-engineering-projects/list`)
      .then(response => response.json())
      .then(res => (res.status !== 200 ? Promise.reject(res.message) : res.data));
  },
  /**
   * Send Get Soil Charge Engineering Project Info Ajax Request.
   * @param {string} id - The id of soil charge engineering project.
   */
  get(id) {
    // return timeoutPromise(
    //   soilChargeEngineeringProjects.soilChargeEngineeringProjectsEdit(id),
    //   1000
    // );
    // return timeoutPromise("讀取駕駛車籍失敗", 1000, true);

    return ajax
      .get(`${process.env.REACT_APP_API_URL}/soil-charge-engineering-projects/${id}`)
      .then(response => response.json())
      .then(res => (res.status !== 200 ? Promise.reject(res.message) : res.data));
  },
  /**
   * Send Create Soil Charge Engineering Project Ajax Request.
   * @param {object} info - The info of soil charge engineering project type.
   */
  create(info) {
    // return timeoutPromise("新增成功", 1000);

    return ajax
      .post(`${process.env.REACT_APP_API_URL}/soil-charge-engineering-projects`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => (res.status !== 200 ? Promise.reject(res.message) : res.message));
  },
  /**
   * Send Update Soil Charge Engineering Project Ajax Request.
   * @param {string} id - The id of soil charge engineering project.
   * @param {object} info - The info of soil charge engineering project.
   */
  update(id, info) {
    // return timeoutPromise("修改成功", 1000);

    return ajax
      .put(`${process.env.REACT_APP_API_URL}/soil-charge-engineering-projects/${id}`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => (res.status !== 200 ? Promise.reject(res.message) : res.message));
  },
  /**
   * Send Delete Soil Charge Engineering Project Ajax Request.
   * @param {string} id - The id of soil charge engineering project.
   */
  delete(id) {
    // return timeoutPromise("刪除成功", 1000);

    return ajax
      .delete(`${process.env.REACT_APP_API_URL}/soil-charge-engineering-projects/${id}`)
      .then(response => response.json())
      .then(res => (res.status !== 200 ? Promise.reject(res.message) : res.message));
  }
};
